import Vue from 'vue'
import Vuex from 'vuex'
import general from './modules/general'
import { vuexfireMutations } from "vuexfire";



Vue.use(Vuex)

export const store = new Vuex.Store({
         mutations: vuexfireMutations,
         modules: {
           general,
         },
       });